import { apiRequest } from './api';

export const actionsApiService = {
  // Actions CRUD
  getActions: async () => {
    return await apiRequest('/actions/actions/');
  },
  
  getAction: async (id) => {
    return await apiRequest(`/actions/actions/${id}/`);
  },
  
  createAction: async (data) => {
    return await apiRequest('/actions/actions/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
  
  updateAction: async (id, data) => {
    return await apiRequest(`/actions/actions/${id}/`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },
  
  deleteAction: async (id) => {
    return await apiRequest(`/actions/actions/${id}/`, {
      method: 'DELETE',
    });
  },

  // Active/Passive Actions
  getActiveActions: async () => {
    return await apiRequest('/actions/actions/active/');
  },
  
  getPassiveActions: async () => {
    return await apiRequest('/actions/actions/passive/');
  },

  // Helper APIs (stopsales'den)
  getHotels: async () => {
    return await apiRequest('/sales/hotels/');
  },
  
  getAgencies: async () => {
    return await apiRequest('/sales/agencies/');
  },
  
  getMarkets: async () => {
    return await apiRequest('/sales/markets/');
  },
  
  getOperators: async () => {
    return await apiRequest('/sales/operators/');
  },
  
  getDateTypes: async () => {
    return await apiRequest('/sales/datetypes/');
  },
  
  getOpenStopTypes: async () => {
    return await apiRequest('/sales/openstoptypes/');
  },
  
  getMaleOnly: async () => {
    return await apiRequest('/sales/maleonly/');
  },
  
  getRoomTypes: async () => {
    return await apiRequest('/sales/roomtypes/');
  }
};

export default actionsApiService;